import { Alert, Snackbar } from "@mui/material";

export default function Toast({
  open,
  onClose,
  severity,
  message,
  autoHideDuration = 1500,
  sx,
  alertSx,
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      sx={{
        top: "12vh !important",
        left: "50vw !important",
        bottom: "auto !important",
        translate: "-50%",
        ...sx,
      }}
    >
      <Alert severity={severity || "info"} sx={{ width: "100%", ...alertSx }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

